export default __webpack_public_path__ + "static/iphonex-24-a48cbbd62a6568cdc617ba266dbbe0e2.png";